const viewBookingES = {
	header: {
		title: "Resumen de la reserva",
	},
	status: {
		confirmed: "Confirmada",
		cancelled: "Cancelada",
		in_progress: "En progreso",
		pending: "Pendiente",
	},
	details: {
		services: "Servicios:",
		staff: "Personal:",
		date: "Fecha:",
		time: "Hora:",
		location: "Ubicación",
	},
	sidebar: {
		location: "Ubicación",
		getDirections: "Cómo llegar",
	},
	manage: {
		title: "Gestionar reserva",
		rescheduleInfo: "Reprograma tu cita",
		rescheduleBtn: "Reprogramar",
		cancelBtn: "Cancelar reserva",
		backBtn: "Volver",
	},
	misc: {
		confirmationEmail: "Se envió un correo de confirmación a",
	},
};
export default viewBookingES;
